module.exports = __webpack_public_path__ + "img/warning.1571b6ed.svg";